import Vue from 'vue'
import store from '@/store'

export default new Vue({
  methods: {
    openDialog (dialogData) {
      store.commit('setDialogData', dialogData)

      return new Promise((resolve, reject) => {
        this.onDialogResove = resolve
        this.onDialogReject = reject
      })
    },
    openError (errorData) {
      store.commit('setErrorData', errorData)

      return new Promise((resolve, reject) => {
        this.onErrorResove = resolve
        this.onErrorReject = reject
      })
    },
    onDialogResove () {
      // no-op
    },
    onDialogReject () {
      // no-op
    },
    resolveDialog (value) {
      store.commit('setDialogData', null)
      setTimeout(() => {
        if (this.onDialogResove) {
          this.onDialogResove(value)
        }
      }, 200)
    },
    onErrorResove () {
      // no-op
    },
    onErrorReject () {
      // no-op
    },
    resolveError (value) {
      store.commit('setErrorData', null)
      setTimeout(() => {
        if (this.onErrorResove) {
          this.onErrorResove(value)
        }
      }, 200)
    },
    openToast (message) {
      store.commit('setToastMessage', message)

      return new Promise((resolve, reject) => {
        setTimeout(() => {
          store.commit('setToastMessage', null)
          resolve()
        }, 1000)
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/lib/modal-event.js